import React, { Suspense, lazy } from 'react';
import AuthMarketingSideFallback from '../../common/authMarketingSideFallback/AuthMarketingSideFallback';

const ClockoutExampleSection = lazy(() =>
    import('../../common/clockoutExampleSection/ClockoutExampleSection')
);

export default function SignupSide() {
    return (
        <Suspense fallback={<AuthMarketingSideFallback />}>
            <ClockoutExampleSection
                titleFirstPart="Get Started"
                titleSecondPart="With Clockout"
                titleLastPart="."
                description="Create your account to set up Earned Wage Access (EWA) service."
            />
        </Suspense>
    );
}
